export class HomepageProjectScopes {
  /**
   *
   */
  public scope_label: string | null = null;
}
